import { Component } from '@angular/core';
import { BaseCellComponent } from '../base-cell/base-cell.component';

@Component({
  selector: 'table-cell-html',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  template: `<div #ref [id]="config.id" [innerHTML]="config.text | safeContent" [ngStyle]="config.styles"></div>`,
  standalone: false,
})
export class HtmlCellComponent extends BaseCellComponent {}
